<template>
  <div id="box">
    <footer class="footer">
      <div class="footer-inner container">
        <div class="footer-left">
          <h1>让世界变得有滋有味</h1>

          <dl class="footer-list">
            <div class="footer-col">
              <dt>走进企业</dt>
              <dd><router-link to="/goin#about">走进企业</router-link></dd>
              <dd><router-link to="/goin#history">发展历程</router-link></dd>
              <dd><router-link to="/goin#culture">企业文化</router-link></dd>
              <dd><router-link to="/goin#honor">荣誉资质</router-link></dd>
            </div>
            <div class="footer-col">
              <dt>公司品牌</dt>
              <dd><router-link to="/products?brand=taigang">台港正品</router-link></dd>
              <dd><router-link to="/products?brand=daxijia">大锡家</router-link></dd>
              <dd><router-link to="/products?brand=baixiaole">白小乐</router-link></dd>
            </div>
            <div class="footer-col">
              <dt>品质创新</dt>
              <dd><router-link to="/innovation#rd">研发实力</router-link></dd>
              <dd><router-link to="/innovation#university">高校合作</router-link></dd>
              <dd><router-link to="/innovation#source">源头控制</router-link></dd>
              <dd><router-link to="/innovation#automation">生产自动化</router-link></dd>
            </div>
            <div class="footer-col">
              <dt>业务概况</dt>
              <dd><router-link to="/business#map">客户地图</router-link></dd>
              <dd><router-link to="/business#model">业务模式</router-link></dd>
              <dd><router-link to="/business#partner">合作伙伴</router-link></dd>

            </div>
            <div class="footer-col">
              <dt>新闻动态</dt>
              <dd><router-link to="/news#industry">行业新闻</router-link></dd>
              <dd><router-link to="/news#company">先优新闻</router-link></dd>
              <dd><router-link to="/news#activity">先优活动</router-link></dd>

            </div>
            <div class="footer-col">
              <dt>联系我们</dt>
              <dd><router-link to="/contact">联系我们</router-link></dd>
              <dd><router-link to="/contact#join">加入我们</router-link></dd>
            </div>
          </dl>
        </div>
        <div class="footer-right">
          <img src="../../public/img/index/xianyou-logo1.png" alt="">
          <div class="qr-wrapper">
            <div class="qr-item">
              <img src="/img/index/erweima_03.png" alt="二维码1"/>
              <p>先优食品视频号</p>
            </div>
            <div class="qr-item">
              <img src="/img/index/yuan-erweima_03.png" alt="二维码2"/>
              <p>先优食品抖音号</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p class="company-name">Copyright © 2026 青岛先优食品有限公司 All Rights Reserved</p>|
        <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-number">鲁ICP备18016437号</a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
#box {
  display: flex;
  flex-direction: column;
}
/* .content {
  flex: 1;
} */
.footer {
  min-height: 465px;
  /* min-height: 560px; */
  background-image: url(/public/img/index/footer-bg_02.png);
  background-size: cover;
  background-position: center;
  margin-top: auto;
  border-top: 1px solid #e0e0e0;
  /* padding: 24px 0; */
  font-size: 14px;
  color: #666;
  border-radius: 25px 25px 0 0;
}
.footer-inner {
  max-width: 80%;
  padding: 3vw 16px 1vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30vw;
  border-bottom: 1px solid #e0e0e0;
}
/* .footer-left {
  flex: 1;
} */
.footer-list {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0 2vw;
  margin: 0;
  padding: 0;
  font-size: clamp(12px, 2.2vw, 16px);
  color: #fff;
}

.footer-col dd {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.footer-col dt {
  font-weight: bold;
  margin-bottom: 2rem;
  text-align: center;
}
.footer-col dd {
  margin: 0 0 15px 0;
  text-align: center;
  font-weight: 400;
}
.footer-col dd a {
  color: #fff;
  text-decoration: none;
  transition: opacity 0.3s ease;
}
.footer-col dd a:hover {
  opacity: 0.7;
}
.footer-left h1 {
  font-size: clamp(20px, 4vw, 50px);
  font-weight: 500;
  color: #fff;
  margin-bottom: 3vw;
  /* text-align: center; */
}

.footer-right {
  flex-shrink: 0;
}
.footer-right img{
  width: 94%;
  height: 69px;
  margin-bottom: 4vw;
}

.qr-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 2vw;
  min-width: 220px;
}
.qr-item {
  text-align: center;
}
.qr-item img {
  width: 18vw;
  height: 18vw;
  max-width: 100px;
  max-height: 100px;
  /* background: #ddd; */
  border-radius: 4px;
  display: block;
  margin: 0 auto 8px;
}
.qr-item p {
  margin: 0;
  font-size: clamp(12px, 2vw, 16px);
  color: #fff;
}

.footer-bottom {
  max-width:80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  margin-top: 1rem;
}

.company-name {
  margin: 0;
  font-size: clamp(12px, 1.8vw, 14px);
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.icp-number {
  margin: 0;
  font-size: clamp(12px, 1.8vw, 14px);
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-number:hover {
  color: rgba(255, 255, 255, 1);
}

@media (max-width: 768px) {
  .footer {
    display: none;
  }
  .footer-inner {
    flex-direction: column;
    gap: 6vw;
  }
  .footer-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 4vw 2vw;
    font-size: 0.875rem;
  }
  .footer-left h1 {
    font-size: 1.5rem;
    text-align: center;
  }
  .qr-wrapper {
    justify-content: center;
  }
  .qr-item p {
    font-size: 0.875rem;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .footer-list {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>